/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Projects_TitleInputs */

const en_meta_projects_title = /** @type {(inputs: Meta_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects — delivered software and design concepts | Lindevo`)
};

const lv_meta_projects_title = /** @type {(inputs: Meta_Projects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbi — programmatūra un dizaina koncepti | Lindevo`)
};

/**
* | output |
* | --- |
* | "Projects — delivered software and design concepts \| Lindevo" |
*
* @param {Meta_Projects_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_projects_title = /** @type {((inputs?: Meta_Projects_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Projects_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_projects_title(inputs)
	return en_meta_projects_title(inputs)
});